import React ,{ useEffect }from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import { Scrollbars } from 'react-custom-scrollbars';
import CircularProgress from '@material-ui/core/CircularProgress';
function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: 700,
    },
    tabs: {
        border: `2px solid ${theme.palette.divider}`,
        borderRadius: "2",
    },
}));
function ReceiveStopWords(subject,setResponse) {
    setResponse("")
    console.log(subject)
    //    fetch("http://conalysis.ihcs.ac.ir:8080/get_stop_words", {
        fetch("http://conalysis.ihcs.ac.ir:8080/get_stop_words", {

        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body:JSON.stringify({
            subject: subject,
        }),
    })
        .then((response) => response.json())
        .then((responseJson) => {

            setResponse(responseJson)
            // console.log(response);

        })
        .catch((error) => {
            console.log(error);
        });
}
function SubmitStopWord(stopword1, subject,setResponse,setInput) {
    // console.log(response);
    // console.log("here213")
    // console.log(stopword1)
    fetch("http://conalysis.ihcs.ac.ir:8080/set_stop_words", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            stop_word: stopword1,
            subject: subject,
        }),
    })
        .then((response) => response.json())
        .then((responseJson) => {
            setResponse(responseJson)
            setInput("")
            console.log(responseJson);

            // this.setState({
            //     response: responseJson,
            // });
            // console.log(this.state.input)
            // for (var i = 0; i < this.state.response.length; i++) {
            //     this.setState({ input: [...this.state.input, 0] })
            //
            // }
            // console.log(this.state.input)

        })
        .catch((error) => {
            console.log(error);
        });

}
function handleDelete(stopword1, subject,setResponse,setInput) {
    // console.log(response);
    // console.log("here213")
    // console.log(stopword1)
    //    fetch("http://conalysis.ihcs.ac.ir:8080/delete_stop_words", {
        fetch("http://conalysis.ihcs.ac.ir:8080/delete_stop_words", {

        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            stop_word: stopword1,
            subject: subject,
        }),
    })
        .then((response) => response.json())
        .then((responseJson) => {
            setResponse(responseJson)
            // setInput("")
            console.log(responseJson);

        })
        .catch((error) => {
            console.log(error);
        });

}
export default function VerticalTabs() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [input, setInput] = React.useState('')
    const [response, setResponse] = React.useState('')
    const [load, setLoad] = React.useState(true)
    // const handleDelete = () => {
    //     console.info('You clicked the delete icon.');
    // };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        // setLoad(true)
	//        fetch("http://conalysis.ihcs.ac.ir:8080/get_stop_words", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/get_stop_words", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // stop_word: stopword1,
                subject: "عمومی",
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                setLoad(false)
                setResponse(responseJson)
                // console.log(response);

            })
            .catch((error) => {
                console.log(error);
            });
    }, []);
    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="عمومی" {...a11yProps(0)} onClick={() => ReceiveStopWords("عمومی",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="اقتصاد" {...a11yProps(1)} onClick={() => ReceiveStopWords("اقتصاد",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="ادبیات" {...a11yProps(2)} onClick={() => ReceiveStopWords("ادبیات",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="تربیت بدنی" {...a11yProps(3)} onClick={() => ReceiveStopWords("تربیت بدنی",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="تاریخ" {...a11yProps(4)} onClick={() => ReceiveStopWords("تاریخ",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="جغرافیا" {...a11yProps(5)} onClick={() => ReceiveStopWords("جغرافیا",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="حقوق" {...a11yProps(6)} onClick={() => ReceiveStopWords("حقوق",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="روان‌شناسی و علوم تربیتی" {...a11yProps(7)} onClick={() => ReceiveStopWords("روانشناسی علوم تربیتی",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="زبان‌شناسی" {...a11yProps(8)} onClick={() => ReceiveStopWords("زبان",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="علوم اسلامی" {...a11yProps(9)} onClick={() => ReceiveStopWords("علوم اسلامی",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="علوم کتابداری" {...a11yProps(10)} onClick={() => ReceiveStopWords("علوم کتابداری",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="علوم اجتماعی و ارتباطات" {...a11yProps(11)} onClick={() => ReceiveStopWords("علوم اجتماعی ارتباطات",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="علوم سیاسی و روابط بین‌المللی" {...a11yProps(12)} onClick={() => ReceiveStopWords("اقتصاد",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="فلسفه و منطق" {...a11yProps(13)} onClick={() => ReceiveStopWords("فلسفه منطق",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="مدیریت و حسابداری" {...a11yProps(14)} onClick={() => ReceiveStopWords("مدیریت حسابداری",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="مطالعات هنر" {...a11yProps(15)} onClick={() => ReceiveStopWords("مطالعات هنر",setResponse)}/>
                <Tab style={{
                    fontSize: 25
                    , fontFamily: 'Bnazanin'
                }} label="مطالعات زنان" {...a11yProps(16)} onClick={() => ReceiveStopWords("مطالعات زنان",setResponse)}/>
            </Tabs>
            <TabPanel style={{width: "100%",height: 400}} value={value} index={0}>
                <Scrollbars
                    style={{
                    // flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: 600,padding:20
                    // flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    // height: 400,
                }}
                    >
                    <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",padding:20
                    // height: "100"
                }}>
                        {
                            (load===true)  ? <CircularProgress size={70}/> : null

                        }

                    {
                        (response!=="")
                        // (load==t)
                            ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
marginButtom:36,
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word}
                                          onDelete={()=>handleDelete(option.stop_word,"عمومی",setResponse,setInput)}
                                          // onClick={()=>handleDelete(option.stop_word,"عمومی",setResponse,setInput)}
                                          color="primary"/>

                                    )})

                        : null
                    }

                    <div style={{marginRight:16,marginTop:16,marginButtom:36}}>
                        <TextField  id="outlined-basic" variant="outlined"
                                    // value={this.state.stopword1}
                                    // onChange={this.onMinChange}
                                    // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                                    // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:16,marginTop:16,marginButtom:36}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"عمومی",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
                </Scrollbars>
            </TabPanel>


            <TabPanel style={{width: "100%"}} value={value} index={1}>
                {/*{ReceiveStopWords()}*/}
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"اقتصاد",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"اقتصاد",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={2}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"ادبیات",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"ادبیات",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={3}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"تربیت بدنی",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"تربیت بدنی",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={4}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"تاریخ",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"تاریخ",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={5}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"جغرافیا",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"جغرافیا",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={6}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"حقوق",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"حقوق",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={7}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"روانشناسی علوم تربیتی",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"روانشناسی علوم تربیتی",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={8}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"زبان",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"زبان",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={9}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"علوم اسلامی",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"علوم اسلامی",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={10}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"علوم کتابداری",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"علوم کتابداری",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={11}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"علوم اجتماعی ارتباطات",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"علوم اجتماعی ارتباطات",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={12}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"علوم سیاسی روابط الملل",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"علوم سیاسی روابط الملل",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={13}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"فلسفه منطق",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"فلسفه منطق",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={14}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"مدیریت حسابداری",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"مدیریت حسابداری",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={15}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"مطالعات هنر",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"مطالعات هنر",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
            <TabPanel style={{width: "100%"}} value={value} index={16}>
                <div style={{
                    flexDirection: "row", display: "flex", flexWrap: 'wrap', alignItems: "center",
                    height: "100"
                }}>

                    {
                        (response!=="") ?
                            response.map((option, index) => {

                                return (
                                    <Chip style={{
                                        fontSize: 25
                                        , fontFamily: 'Bnazanin', color: "white",
                                        // width: "10%",
                                        marginRight:"2%",
                                        marginTop:"2%",
                                        // height: "50",
                                        position: "relative",
                                        direction: "ltr"
                                    }} label={option.stop_word} onDelete={()=>handleDelete(option.stop_word,"مطالعات زنان",setResponse,setInput)} color="primary"/>

                                )})

                            : null
                    }
                    <div style={{marginRight:"2%",marginTop:"2%",}}>
                        <TextField  id="outlined-basic" variant="outlined"
                            // value={this.state.stopword1}
                            // onChange={this.onMinChange}
                            // value={this.state.textFieldValue} onChange={this.handleTextFieldChange}
                            // ref="myField"
                                    value={input} onInput={e => setInput(e.target.value)}
                        />

                    </div>

                    <Fab style={{marginRight:"1%",marginTop:"2%",}} color="primary" aria-label="add"
                         onClick={() => SubmitStopWord(input,"مطالعات زنان",setResponse,setInput)}
                    >
                        <AddIcon/>
                    </Fab>

                </div>
            </TabPanel>
        </div>
    );
}
